import React from 'react';
import { compose, withProps } from 'recompose';
import classnames from 'classnames';

import { Text } from 'components/core/Typography';
import { Button } from 'components/core/Button';
import { Overlay } from 'components/core/GoogleMap';

export const enhance = compose(
	withProps(
		({ facility, onClick, onMouseEnter, onMouseLeave, selected }) => ({
			className: classnames('search-facility-marker', { selected }),
			location: facility.location,
			label: (
				<>
					<Button
						className="facility-marker-button"
						onClick={onClick}
						onMouseEnter={onMouseEnter}
						onMouseLeave={onMouseLeave}
					>
						<Text
							className="facility-marker-label"
							size="smallMedium"
							color="blue"
							weight="extraBold"
							last
						>
							{typeof facility?.lowestPrice === 'number' &&
							!isNaN(facility?.lowestPrice)
								? `$${Math.floor(facility?.lowestPrice)}`
								: typeof facility?.lowestPrice === 'string' &&
									  facility?.lowestPrice?.trim() !== '' &&
									  !isNaN(
											parseFloat(
												facility?.lowestPrice?.replace(
													/,/g,
													'',
												),
											),
									  )
									? `$${Math.floor(parseFloat(facility?.lowestPrice?.replace(/,/g, '')))}`
									: ''}
						</Text>
					</Button>
				</>
			),
		}),
	),
);

export default enhance(Overlay);
